import React from "react";
import * as S from "./styles";
export var Partnership = function Partnership(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": "true"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }, React.createElement("circle", {
    cx: "16",
    cy: "13.333",
    r: "2.667"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M21.333 23.333H10.667C10.667 20.388 13.054 18 16 18s5.333 2.388 5.333 5.333zM22.667 9.36L26.807 5.247"
  }), React.createElement("circle", {
    cx: "28.667",
    cy: "3.333",
    r: "2.667",
    strokeLinecap: "round"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M23.947 23.973L26.767 26.807"
  }), React.createElement("circle", {
    cx: "28.68",
    cy: "28.667",
    r: "2.667",
    strokeLinecap: "round"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M9.333 9.36L5.193 5.247"
  }), React.createElement("circle", {
    cx: "3.333",
    cy: "3.333",
    r: "2.667",
    strokeLinecap: "round"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M8.053 23.973L5.233 26.807"
  }), React.createElement("circle", {
    cx: "3.32",
    cy: "28.667",
    r: "2.667",
    strokeLinecap: "round"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M22 15.333L26 15.333"
  }), React.createElement("circle", {
    cx: "28.667",
    cy: "15.333",
    r: "2.667",
    strokeLinecap: "round"
  }), React.createElement("path", {
    strokeLinecap: "round",
    d: "M10 15.333L6 15.333"
  }), React.createElement("circle", {
    cx: "3.333",
    cy: "15.333",
    r: "2.667",
    strokeLinecap: "round"
  })));
};